export const vehicleCategoryMapping = new Map([
  // AUTO
  ['BREAK', 'BREAK'],
  ['CABRIOLET', 'CABRIOLET'],
  ['CAMION_PLUS_3T5', 'CAMION DE PLUS DE 3,5T'],
  ['CARAVANNE', 'CARAVANE'],
  ['CITADINE', 'CITADINE'],
  ['COUPE', 'COUPÉ'],
  ['FOURGONETTE', 'FOURGONETTE'],
  ['FOURGON_MOINS_3T5', 'FOURGON DE MOINS DE 3,5T'],
  ['GRANDE_BERLINE', 'GRANDE BERLINE'],
  ['MINIBUS', 'MINIBUS'],
  ['MONOSPACE', 'MONOSPACE'],
  ['MOYENNE_BERLINE', 'MOYENNE BERLINE'],
  ['PICK_UP', 'PICK-UP'],
  ['TOUS_CHEMINS', 'TOUS CHEMINS'],
  ['VEHICULE_SOCIETE', 'VÉHICULE DE SOCIÉTÉ'],
  ['VOITURETTE', 'VOITURETTE'],

  // MOTO
  ['CUSTOM', 'CUSTOM'],
  ['OFFROAD', 'OFFROAD'],
  ['ROADSTER', 'ROADSTER'],
  ['GT', 'GT'],
  ['MINI_MOTO', 'MINI_MOTO'],
  ['MOBYLETTE', 'MOBYLETTE'],
  ['SUPERMOTARD', 'SUPERMOTARD'],
  ['TRAIL', 'TRAIL'],
  ['SPORTIVE', 'SPORTIVE'],
  ['SIDE_CARS', 'SIDE_CAR'],
  ['QUAD', 'QUAD'],
  ['SCOOTER', 'SCOOTER'],
  ['MOTO_DE_COLLECTION', 'MOTO DE COLLECTION'],
  ['REMORQUES_PORTE_MOTO', 'REMORQUES PORTE MOTO'],
  ['RECHERCHE', 'RECHERCHE'],
  ['ACCESSOIRES', 'ACCESSOIRES'],
  ['DIVERS_MOTO', 'DIVERS_MOTO'],
]);
